var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWindCloud = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 41.24 39.531",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.686,16.73a.433.433,0,0,1-.122-.375,7.9,7.9,0,0,0,.1-1.246,7.714,7.714,0,0,0-6.044-7.547.431.431,0,0,1-.294-.234A12.029,12.029,0,0,0,10.008,8.9a.431.431,0,0,1-.352.3A11.185,11.185,0,0,0,0,20.265a11.327,11.327,0,0,0,.1,1.5.435.435,0,0,0,.187.3.428.428,0,0,0,.344.06,4.263,4.263,0,0,1,1.088-.139h1.39a.426.426,0,0,0,.328-.151.421.421,0,0,0,.1-.344,7.733,7.733,0,0,1,7.774-8.956h0A1.718,1.718,0,0,0,13,11.1,8.592,8.592,0,0,1,29.581,9.671a1.718,1.718,0,0,0,1.547,1.146A4.3,4.3,0,0,1,34.963,16.6a1.718,1.718,0,0,0,.629,2.009A5.155,5.155,0,0,1,32.65,28H24.767a.43.43,0,0,0-.265.768,7.788,7.788,0,0,1,2.062,2.444.43.43,0,0,0,.378.225H32.65a8.592,8.592,0,0,0,6.037-14.7Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.718,20.81H14.606a5.155,5.155,0,1,0,0-10.31,1.718,1.718,0,1,0,0,3.437,1.718,1.718,0,1,1,0,3.437H1.718a1.718,1.718,0,1,0,0,3.437Z",
    transform: "translate(0 7.187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.762,17.5H1.718a1.718,1.718,0,0,0,0,3.437H19.762a1.718,1.718,0,0,1,0,3.437,1.718,1.718,0,0,0,0,3.437,5.155,5.155,0,1,0,0-10.31Z",
    transform: "translate(0 12.216)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWindCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wind_cloud.ef4dc4f3.svg";
export { ForwardRef as ReactComponent };